import api from './client';

export async function register(email, password, inviteCode) {
  const { data } = await api.post('/api/auth/register', { email, password, inviteCode });
  return data.data; // { token, user }
}

export async function login(email, password) {
  const { data } = await api.post('/api/auth/login', { email, password });
  return data.data; // { token, user }
}

export async function logout() {
  await api.post('/api/auth/logout');
}

export async function refreshToken() {
  const { data } = await api.post('/api/auth/refresh');
  return data.data; // { token, user }
}

/* ── Forgot / reset password ── */

export async function forgotPassword(email) {
  const { data } = await api.post('/api/auth/forgot-password', { email });
  return data.data; // { message }
}

export async function checkResetToken(token) {
  const { data } = await api.get(`/api/auth/reset-password/${encodeURIComponent(token)}`);
  return data.data; // { valid }
}

export async function resetPassword(token, password) {
  const { data } = await api.post('/api/auth/reset-password', { token, password });
  return data.data; // { token, user } - logged in straight away
}

export function getStoredAuth() {
  // Live mode - no localStorage, auth comes from refresh token cookie
  return null;
}
